import * as core from '../../../../../../../core'

import { query } from './area-of-concern-by-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'area.of.concern.by.workstream',
    description: 'Chart view of area of concern by workstream',
    name: 'Area of Concern by Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
